var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowFill2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.00 48.00",
    "data-guides": "{\"vertical\":[],\"horizontal\":[]}",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#24cd73",
    stroke: "#24cd73",
    fillOpacity: 1,
    strokeWidth: 2,
    strokeOpacity: 1,
    alignmentBaseline: "baseline",
    baselineShift: "baseline",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "cls-1",
    id: "tSvg159236ca9a0",
    title: "Path 1",
    d: "M6.86 24C9.9067 24 12.9533 24 16 24C16 16.3333 16 8.6667 16 1C21.3333 1 26.6667 1 32 1C32 8.6667 32 16.3333 32 24C35.0467 24 38.0933 24 41.14 24C35.4267 31.6667 29.7133 39.3333 24 47C18.2867 39.3333 12.5733 31.6667 6.86 24Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFill2);
export default __webpack_public_path__ + "static/media/arrow-fill-2.623eeaba765d2e0a19ab2985696fe65c.svg";
export { ForwardRef as ReactComponent };